module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Lt-185257a91ad0af6ec3b696583ca5b51c.woff2";